module.exports = __webpack_public_path__ + "img/cameraplus.ab0b88b7.svg";